import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import ImageCropper from "./ImageCropper";

import "./styles/PopupCropTemplateImage.css";

const PopupCropTemplateImage = ({
  open,
  image,
  selectTemplate,
  measures,
  exitCrop,
  onGoBack,
  continueCrop,
  setCroppedFile,
  setCroppedUrl,
  stepNumber = 3,
}) => {
  const handleGoBack = onGoBack || exitCrop;

  return (
    <GenericPopup
      open={open}
      className="artwork-options__download-template-templates-selectImg"
    >
      <div className="artwork-options__download-template_header-scale-img">
        <BackArrowIcon
          className="artwork-options__download-template_header-back"
          onClick={handleGoBack}
        />
        <p className="artwork-options__download-template_header-text">
          Generate template
        </p>
        <XIcon
          className="artwork-options__download-template_header-close"
          onClick={exitCrop}
        />
        <p className="artwork-options__download-template_header-step-text">
          <span className="artwork-options__download-template_header-step-text-span">
            {stepNumber}. {" "}
          </span>
          Move and scale the artwork
        </p>
      </div>
      <ImageCropper
        source={image}
        width={selectTemplate && measures[selectTemplate].width}
        height={selectTemplate && measures[selectTemplate].height}
        exitCrop={exitCrop}
        continueCrop={continueCrop}
        setCroppedUrl={setCroppedUrl}
        setCroppedFile={setCroppedFile}
        continueLabel="Preview"
      />
    </GenericPopup>
  );
};

export default PopupCropTemplateImage;
